export function DividerSection() {
  return <hr data-testid="typed-section-divider" className="border-border my-5" />;
}
